import { Box, Checkbox, Grid, Typography } from '@material-ui/core';
import React, { useEffect, useReducer } from 'react';
import KenSelectWrap from '../../../../global_components/KenSelect';
import KenDateTimePicker from '../../../../global_components/KenDateTimePicker';
import {
  EVENT_TYPES,
  RECURRENT_DAYS,
} from '../../../../Utils/helper/schedulerHelper';
import KenButton from '../../../../global_components/KenButton';
import { createBookedSlot, sessionCUD } from '../../../../Utils/apiServices';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { useToggleStyles } from '../SessionScheduler';
import { useAppContext } from '../../../../Utils/context';

const reducer = function (state, action) {
  switch (action.type) {
    case 'update':
      return { ...state, [action.key]: action.value };

    case 'facultyOptions':
      return {
        ...state,
        facultyOptions: action?.value?.map((f) => ({
          label: f.facultyName,
          value: f.id,
        })),
      };
    case 'faciltiyOptions':
      return {
        ...state,
        facilityOptions: action?.value?.map((f) => ({
          label: f.facilityName,
          value: f.id,
        })),
      };

    case 'courseVersionData':
      return {
        ...state,
        courseVersionData: action.value,
        subjectOptions: action.value?.map((s) => ({
          value: s.id,
          label: s.courseName,
        })),
      };

    case 'subjectSelected':
      return {
        ...state,
        subject: action.value,
        section: '',
        sectionOptions: getSectionOptions(
          state.courseVersionData,
          action.value
        ),
      };

    default:
      return state;
  }
};

const getSectionOptions = function (data = [], subjectId) {
  if (!subjectId) {
    return [];
  }
  return data
    ?.find((e) => e.id === subjectId)
    ?.courseOffering?.map((c) => ({
      label: c.courseSectionId,
      value: c.id,
    }));
};

export default function SessionCreateUpdate(props) {
  const {
    faculties = [],
    facilities = [],
    activityTypes = [],
    courseVersionData = [],
    onCancel,
    onSuccess,
    term,
    event = { isCreateFromReference: false },
  } = props;

  const toggleClasses = useToggleStyles();

  useEffect(() => {
    dispatch({ type: 'faciltiyOptions', value: facilities });
  }, [facilities]);
  useEffect(() => {
    dispatch({ type: 'facultyOptions', value: faculties });
  }, [faculties]);
  useEffect(() => {
    dispatch({ type: 'courseVersionData', value: courseVersionData });
  }, [courseVersionData]);

  const subjectId =
    event?.SubjectPlanner?.courseVersionId || event?.courseVersionId || '';
  const [state, dispatch] = useReducer(reducer, {
    ...event,
    activity: event?.activity || event?.activityType || '',
    faculty: event?.FacultyBooking?.facultyId || '',
    facility: event?.FacilityBooking?.facilityId || '',
    subject: subjectId,
    section:
      event?.SubjectPlanner?.courseOfferingId || event?.courseOfferingId || '',
    sectionOptions: subjectId
      ? getSectionOptions(courseVersionData, subjectId)
      : [],
  });
  const {
    activity = '',
    startDate = '',
    startTime = '',
    endDate = '',
    endTime = '',
    recurrent = false,
    subject = '',
    section = '',
    faculty = '',
    facility = '',
    facultyOptions = [],
    facilityOptions = [],
    subjectOptions = [],
    recurrentDays = [],
    sectionOptions,
    id,
    isCreateFromReference,
    eventType,
  } = state;

  const { handleSnackbarOpen, handleLoader } = useAppContext();

  const onSubmit = () => {
    if (eventType === EVENT_TYPES.ACTIVITY) {
      createActivity();
    } else if (eventType === EVENT_TYPES.SESSION) {
      createSession();
    }
  };

  const createSession = () => {
    const payload = {
      Operation: 'Create',
      Session: [
        {
          courseOfferingId: section,
          sessionId: id,
          activityType: activity,
          startDate: `${startDate}T${startTime}:00.000Z`,
          endDate: `${endDate}T${endTime}:00.000Z`,
          facultyId: faculty,
          facilityId: facility,
        },
      ],
    };

    handleLoader(true);
    sessionCUD(payload)
      .then((res) => {
        handleLoader(false);
        if (res) {
          onSuccess();
          handleSnackbarOpen('success', 'Created Successfully');
        }
      })
      .catch((err) => {
        handleLoader(false);
        handleSnackbarOpen('error', 'Error saving details');
        console.log(err);
      });
  };

  const createActivity = () => {
    const payload = {
      Operation: 'Create',
      FacilityFacultyBooking: {
        termId: term,
        facultyId: faculty,
        facilityId: facility,
        // facilityBookingId: '',
        daySelected: recurrentDays.join(';'),
        courseVersionId: subject,
        courseOfferingId: section,
        academicPlannerActivityId: event?.academicPlannerActivityId || '',
        activityType: activity,
        startDate: `${startDate}T${startTime}:00.000Z`,
        endDate: `${endDate}T${endTime}:00.000Z`,
      },
    };

    handleLoader(true);
    createBookedSlot(payload)
      .then((res) => {
        // toast success
        handleLoader(false);
        if (res) {
          onSuccess();
          handleSnackbarOpen('success', 'Created Successfully');
        }
      })
      .catch((err) => {
        // toast error saving
        handleLoader(false);
        handleSnackbarOpen('error', 'Error saving details');
        console.log(err);
      });
  };

  return (
    <Box>
      <Box mb={2}>
        <Typography variant="h6">
          <b>Add Session</b>
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <KenSelectWrap
            disabled={isCreateFromReference}
            label="Type of sessions"
            options={activityTypes}
            value={activity}
            // dropdownColor="#FFFFFF"
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'activity',
                value: e.target.value,
              });
            }}
            // styles={CustomStyle}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <KenDateTimePicker
            name={'startDate'}
            label="Start Date"
            // disabled={false}
            value={startDate}
            type="date"
            required={true}
            // defaultValue={startData}
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'startDate',
                value: e.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <KenDateTimePicker
            name={'startTime'}
            label="Start Time"
            value={startTime}
            type="time"
            required={true}
            // defaultValue={startData}
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'startTime',
                value: e.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <KenDateTimePicker
            name={'endDate'}
            label="End Date"
            // disabled={false}
            value={endDate}
            type="date"
            required={true}
            // defaultValue={startData}
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'endDate',
                value: e.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <KenDateTimePicker
            name={'endTime'}
            label="End Time"
            value={endTime}
            type="time"
            required={true}
            // defaultValue={startData}
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'endTime',
                value: e.target.value,
              });
            }}
          />
        </Grid>
        {!id && eventType === EVENT_TYPES.ACTIVITY && (
          <Grid item xs={12} md={12}>
            <Checkbox
              checked={recurrent}
              onChange={(e) => {
                dispatch({
                  type: 'update',
                  key: 'recurrent',
                  value: !recurrent,
                });
              }}
              color="secondary"
            />
            Recurrent Session
          </Grid>
        )}
        {recurrent && (
          <Grid container spacing={0}>
            <Grid item xs={12} md={12}>
              <div style={{ display: 'flex', paddingLeft: '16px' }}>
                <ToggleButtonGroup
                  size="small"
                  color="primary"
                  value={recurrentDays}
                  onChange={(e, newV) => {
                    dispatch({
                      type: 'update',
                      key: 'recurrentDays',
                      value: newV,
                    });
                  }}
                  aria-label="text formatting"
                >
                  {RECURRENT_DAYS.map((d) => (
                    <ToggleButton
                      classes={toggleClasses}
                      value={d.value}
                      aria-label="bold"
                    >
                      {d.label}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </div>
            </Grid>
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <KenSelectWrap
            disabled={isCreateFromReference}
            label="Subject"
            options={subjectOptions}
            // disabled={false}
            value={subject}
            // dropdownColor="#FFFFFF"
            onChange={(e) => {
              dispatch({
                type: 'subjectSelected',
                value: e.target.value,
              });
            }}
            // styles={CustomStyle}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <KenSelectWrap
            label="Section"
            options={sectionOptions}
            value={section}
            dropdownColor="#FFFFFF"
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'section',
                value: e.target.value,
              });
            }}
            // styles={CustomStyle}
            required
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <KenSelectWrap
            label="Faculty"
            options={facultyOptions}
            value={faculty}
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'faculty',
                value: e.target.value,
              });
            }}
            // styles={CustomStyle}
            required
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <KenSelectWrap
            label="Facility"
            options={facilityOptions}
            value={facility}
            dropdownColor="#FFFFFF"
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'facility',
                value: e.target.value,
              });
            }}
            // styles={CustomStyle}
            required
          />
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="end" mt={4}>
        <KenButton
          variant="secondary"
          onClick={onCancel}
          style={{ marginRight: 8 }}
        >
          Cancel
        </KenButton>
        <KenButton variant="primary" onClick={onSubmit}>
          Submit
        </KenButton>
      </Box>
    </Box>
  );
}
